import React from "react";
import T from "prop-types";
import {
  toggleSwitch,
  translateProps,
  renderIf
} from "MODULES/shared/decorators";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { WAREHOUSE } from "MODULES/users/constants";
import { Forbidden } from "MODULES/shared/components";
import { CANCELLED, SHIPPED } from "APP_ROOT/constants";
import New from "./New";

export function Heading({ creating, open, close }) {
  return (
    <h2 style={{ marginTop: 26 }}>
      Parts
      <AddPart open={open} />
      <New creating={creating} close={close} />
    </h2>
  );
}

Heading.propTypes = {
  creating: T.bool.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired
};

const Button = ({ open }) => (
  <Forbidden roles={[WAREHOUSE]}>
    <button
      type="button"
      className="btn btn-primary btn-hollow pull-right"
      onClick={open}
    >
      <i className="fa fa-fw fa-plus">&nbsp;</i>Add Part
    </button>
  </Forbidden>
);

Button.propTypes = {
  open: T.func.isRequired
};

const withExchangeAndShipment = translateProps(({ salesOrder }) => ({
  cancelled: salesOrder.get(CANCELLED),
  exchanged: salesOrder.get("has_exchange"),
  shipped: salesOrder.get(SHIPPED)
}));

const forOpenItems = renderIf(
  ({ exchanged, shipped, cancelled }) => !exchanged && !shipped && !cancelled
);

const AddPart = withSalesOrder(withExchangeAndShipment(forOpenItems(Button)));

export default toggleSwitch("creating")(Heading);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Heading.jsx